document.addEventListener('DOMContentLoaded', function() {
  // Only enable accordion on mobile (< 1270px)
  function initFooterAccordion() {
    const footerMenuItems = document.querySelectorAll('.footer-menu-item');
    
    footerMenuItems.forEach(item => {
      const title = item.querySelector('.footer-menu-item--title');
      const submenu = item.querySelector('.footer-menu-submenu');
      
      if (!title || !submenu) return;
      
      // Add click handler
      title.addEventListener('click', function(e) {
        // Only prevent default and toggle on mobile
        if (window.innerWidth < 1270) {
          e.preventDefault();
          
          // Toggle active class on parent item
          item.classList.toggle('active');
          
          // Toggle submenu visibility
          if (item.classList.contains('active')) {
            submenu.style.maxHeight = submenu.scrollHeight + 'px';
          } else {
            submenu.style.maxHeight = '0';
          }
        }
      });
    });
  }
  
  // Initialize accordion
  initFooterAccordion();
  
  // Handle window resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      const footerMenuItems = document.querySelectorAll('.footer-menu-item');
      
      footerMenuItems.forEach(item => {
        const submenu = item.querySelector('.footer-menu-submenu');
        if (!submenu) return;
        
        // Reset styles on desktop
        if (window.innerWidth >= 1270) {
          submenu.style.maxHeight = '';
          item.classList.remove('active');
        } else {
          // On mobile, collapse all by default if not active
          if (!item.classList.contains('active')) {
            submenu.style.maxHeight = '0';
          }
        }
      });
    }, 250);
  });
});
